module.exports = angular.module('cartographer.map.inspector.options', [])

_ = require 'underscore'

module.exports.directive 'crtOptionsInspector', $DI (crtLog, crtConfig, crtString, crtAuth, crtMapCollaborationModel, crtMapPermissionModel) ->
  return {
    restrict: 'A'
    replace: true
    template: require './options.tpl.html'
    bindToController: true
    controllerAs: 'crtOptionsInspector'
    scope:
      featureLayer : '='  # crtFeatureLayer
      from         : '='  # or(Date, null)
      to           : '='  # or(Date, null)
      crossws      : '='  # or(boolean, null)
      urlParams    : '='  # object(string, string)
      subdomain    : '='  # string
      selection    : '='  # crtFeatureMapSelection
      widget       : '='  # or(boolean, null)
      downloadLink : '=?' # or(string -> string, null)
      onBackClick  : '='  # () -> void
    controller: $DI ($scope) ->
      crtOptionsInspector = this

      crtLog.debug('crtOptionsInspector.controller', crtOptionsInspector)

      $scope.$watch 'crtOptionsInspector.selection.radius()', (radius) ->
        crtOptionsInspector.selectionRadius = radius
        return

      $scope.$watch 'crtOptionsInspector.selectionRadius', (radius) ->
        crtOptionsInspector.selection = crtOptionsInspector.selection.withRadius(radius)
        return

      crtOptionsInspector.embedCode = 'Loading, please wait...'

      crtOptionsInspector.showDates = crtOptionsInspector.featureLayer?.hasTimestamp

      crtOptionsInspector.showCollaboration = do ->
        switch crtOptionsInspector.featureLayer.collaborationModel
          when crtMapCollaborationModel.CrossWorkspace  then crtOptionsInspector.widget != true
          when crtMapCollaborationModel.SingleWorkspace then false
          else                                               false

      crtOptionsInspector.crossWorkspaceButtonLabel = (enabled) ->
        if enabled
          "All workspaces"
        else
          "This workspace"

      crtOptionsInspector.crossWorkspaceLabel = (enabled) ->
        if enabled
          "Include data from other workspaces"
        else
          "Only show data from this workspace"

      crtOptionsInspector.showDownloads = do ->
        a = !crtOptionsInspector.widget
        b = crtOptionsInspector.downloadLink? &&
        c = switch crtOptionsInspector.featureLayer.permissionModel
          when crtMapPermissionModel.RoleBased then crtAuth.isMapViewer(crtOptionsInspector.featureLayer.id)
          when crtMapPermissionModel.Workspace then crtAuth.isActive()
          when crtMapPermissionModel.Active    then crtAuth.isActive()
          when crtMapPermissionModel.Public    then true
          else                                      false
        # crtLog.debug('crtOptionsInspector.showDownloads', { a, b, c, perms: crtOptionsInspector.featureLayer.permissionModel })
        a && b && c

      crtOptionsInspector.showEmbedCode = do ->
        a = !crtOptionsInspector.widget
        b = switch crtOptionsInspector.featureLayer.permissionModel
          when crtMapPermissionModel.RoleBased then false
          when crtMapPermissionModel.Workspace then false
          when crtMapPermissionModel.Active    then false
          when crtMapPermissionModel.Public    then true
          else                                      false
        # crtLog.debug('crtOptionsInspector.showEmbedCode', { a, b, perms: crtOptionsInspector.featureLayer.permissionModel })
        a && b

      $scope.$watch 'crtOptionsInspector.urlParams', (params) ->
        encodedParams =
          _.chain(params)
          .pairs()
          .filter(([ key, value ]) => value?)
          .map(([ key, value ]) => "data-#{key}=\"#{crtString.escapeHtml(value)}\"")
          .value()

        crtOptionsInspector.embedCode =
          """
          <!-- Start of Cartographer map widget -->
          <script src="https://widget.cartographer.io/map/v1/loader.js"></script>
          <div data-cartographer-map
               data-subdomain=\"#{crtOptionsInspector.subdomain}\"
               #{encodedParams.join("\n     ")}></div>
          <!-- End of Cartographer map widget -->
          """
        return

      return
  }
